export default "__VITE_ASSET__B20ZONJ$__"